import type { PhoneInputProps, PhoneInputValue } from '../PhoneInput/index.ts';
import type { FormComponentProps } from './types.ts';
import { PhoneInput } from '../PhoneInput/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormPhoneInput(
  props: FormComponentProps<Omit<PhoneInputProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<PhoneInputValue | null>();

  return (
    <PhoneInput
      key={field.name}
      {...usePropsFromField(props, field)}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
      value={field.state.value}
    />
  );
}
